<template>
  <article class="last-news">
    <div class="last-news__title">
      Дайджест FAKT
    </div>
    <div class="last-news__wrapper">
      <div class="last-news__img-frame mb-2">
        <v-img src="/img/news.png" class="last-news__img" />
      </div>
      <div class="last-news__description">
        FAKT начал подключение филиалов в Санкт-Петербурге...
      </div>
    </div>
  </article>
</template>

<script>
  export default {
    name: 'LastNews',
  }
</script>

<style scoped lang="less">
.last-news {
  &__title {
    color: #999;
    font-size: 12px;
  }

  &__wrapper {
    border: 2px solid #dbdfe6;
    border-radius: 5px;
    background-color: #f1f3f6;
    padding: 8px 10px;
  }

  // рамка держит внешний размер: картинка зумится внутри неё, за края не выходит
  &__img-frame {
    overflow: hidden;
    border-radius: 5px;
  }

  &__img {
    border-radius: 5px;
    transition: transform 0.3s ease;
  }

  &:hover &__img {
    transform: scale(1.18);
  }

  &__description {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
</style>
